export default __webpack_public_path__ + "static/media/internation-house-of-tea.698504f5.png";